module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            Redeem request\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-margin"
  }, [_c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.formatNegativeAmount(_vm.redeemNote.principalAmount)))])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.formatNegativeAmount(_vm.redeemNote.currentAccrintValue)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    class: _vm.redeemNote.redeemFull ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.redeemNote.redeemFull),
      expression: "redeemNote.redeemFull"
    }],
    attrs: {
      "id": "ritema",
      "name": "ritem",
      "type": "radio",
      "disabled": !_vm.redeemNote.isNewRedemption
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.redeemNote.redeemFull, true)
    },
    on: {
      "change": function($event) {
        _vm.resetRadioValue()
      },
      "__c": function($event) {
        _vm.redeemNote.redeemFull = true
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ritema"
    }
  })])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    class: !_vm.redeemNote.redeemFull ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.redeemNote.redeemFull),
      expression: "redeemNote.redeemFull"
    }],
    attrs: {
      "id": "ritemb",
      "name": "ritem",
      "type": "radio",
      "disabled": !_vm.redeemNote.isNewRedemption
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.redeemNote.redeemFull, false)
    },
    on: {
      "change": function($event) {
        _vm.resetRadioValue()
      },
      "__c": function($event) {
        _vm.redeemNote.redeemFull = false
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ritemb"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.redeemNote.fundingSource),
      expression: "redeemNote.fundingSource"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "FundingSource",
      "id": "FundingSource",
      "placeholder": "Please select",
      "disabled": !_vm.redeemNote.isNewRedemption
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.redeemNote.fundingSource = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_vm._l((_vm.redeemNote.fundingSources), function(fs) {
    return _c('option', {
      key: fs.id,
      domProps: {
        "value": fs.id
      }
    }, [_vm._v(_vm._s(fs.name))])
  }), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.donateFundingSource.name
    }
  }, [_vm._v(_vm._s(_vm.donateFundingSource.text))])], 2)]), _vm._v(" "), (!this.redeemNote.fundingSource || !this.redeemNote.fundingSources || this.redeemNote.fundingSources.length === 0) ? _c('p', {
    staticClass: "top-margin",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', [_vm._v("There must be a valid bank account for the redemption.")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [(_vm.redeemNote.redeemFull) ? _c('p', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.formatNegativeAmount(_vm.getUnformattedValue(_vm.redeemNote.redeemAmount))))]) : _vm._e(), _vm._v(" "), (!_vm.redeemNote.redeemFull) ? _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.redeemNote.redeemAmount),
      expression: "redeemNote.redeemAmount"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "id": "redeemPartialAmount",
      "autocomplete": "off",
      "required": "",
      "disabled": !_vm.redeemNote.isNewRedemption
    },
    domProps: {
      "value": (_vm.redeemNote.redeemAmount)
    },
    on: {
      "change": _vm.removeNegative,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.redeemNote.redeemAmount = $event.target.value
      }
    }
  }) : _vm._e()])])]), _vm._v(" "), (_vm.checkRemainingPrincipalAmount()) ? _c('p', {
    staticClass: "top-margin",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', [_vm._v("Please change this redemption request to ensure the remaining principal on the note is $20 or more.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.redeemNote.serviceFee),
      expression: "redeemNote.serviceFee"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "id": "serviceFee",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.redeemNote.serviceFee)
    },
    on: {
      "change": _vm.removeNegative,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.redeemNote.serviceFee = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('p', {
    staticClass: "text-right total-amount"
  }, [_vm._v(_vm._s(_vm.getPrincipalToRepay()))])])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator2"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin mb-lg"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [(_vm.redeemNote.redeemFull) ? _c('p', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.formatNegativeAmount(_vm.redeemNote.currentAccrintValue)))]) : _vm._e(), _vm._v(" "), (!_vm.redeemNote.redeemFull) ? _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.redeemNote.interestToReedem),
      expression: "redeemNote.interestToReedem"
    }],
    class: {
      'form-control text-right': true, 'form-control-error': _vm.getUnformattedValue(_vm.redeemNote.interestToReedem) > _vm.getUnformattedValue(_vm.redeemNote.currentAccrintValue)
    },
    attrs: {
      "id": "interestAmount",
      "autocomplete": "off",
      "required": "",
      "disabled": !_vm.redeemNote.isNewRedemption
    },
    domProps: {
      "value": (_vm.redeemNote.interestToReedem)
    },
    on: {
      "change": _vm.removeNegative,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.redeemNote.interestToReedem = $event.target.value
      }
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.getUnformattedValue(_vm.redeemNote.interestToReedem) > _vm.getUnformattedValue(_vm.redeemNote.currentAccrintValue)) ? _c('p', {
    staticClass: "top-margin",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', [_vm._v("The interest payment cannot be greater than the accrued interest")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator2"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('p', {
    staticClass: "text-right total-amount"
  }, [_vm._v(_vm._s(_vm.getTotalPaidOut()))])])])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.redeemNote.redemptionCategoryId),
      expression: "redeemNote.redemptionCategoryId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "RedemptionCategory",
      "id": "RedemptionCategory",
      "placeholder": "Please select"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.redeemNote.redemptionCategoryId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.redeemNote.redemptionCategories), function(rc) {
    return _c('option', {
      key: rc.id,
      domProps: {
        "value": rc.id
      }
    }, [_vm._v("\n                      " + _vm._s(rc.label) + "\n                    ")])
  }))])])]), _vm._v(" "), (_vm.displayRedemptionCategoryHelperText) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.redeemNote.redemptionCategoryHelperText),
      expression: "redeemNote.redemptionCategoryHelperText",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "redemptionCategoryHelperText",
      "autocomplete": "off",
      "placeholder": "Enter a redemption category...",
      "required": ""
    },
    domProps: {
      "value": (_vm.redeemNote.redemptionCategoryHelperText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.redeemNote.redemptionCategoryHelperText = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.redeemNote.redeemFull && this.totalPaidOut <= 0) ? _c('p', {
    staticClass: "top-margin",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', [_vm._v("Please ensure the total paid out is more than $0.")])]) : _vm._e(), _vm._v(" "), (_vm.displayPaidOutError(_vm.redeemNote.redeemFull)) ? _c('p', {
    staticClass: "top-margin",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', [_vm._v("Please change this redemption request to ensure the total paid out and Principal to repay is more than $0.")])]) : _vm._e(), _vm._v(" "), (!_vm.redeemNote.isNewRedemption && !this.noteHasSufficientFunds) ? _c('p', {
    staticClass: "top-margin",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', [_vm._v("There are insufficient funds on this note to pay these transactions. Please edit the redemption values before approving payment.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("Please append your comment below *")]), _vm._v(" "), _c('restricted-textarea', {
    attrs: {
      "input": _vm.redeemNote.comment,
      "limit": 255,
      "id": "comment",
      "required": true,
      "placeholder": ""
    },
    on: {
      "inputUpdated": _vm.commentUpdated
    }
  }), _vm._v(" "), (!_vm.redeemNote.comment || _vm.initialComment === _vm.redeemNote.comment) ? _c('p', {
    staticClass: "top-margin",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', [_vm._v("You must enter or append a comment.")])]) : _vm._e()], 1)]), _vm._v(" "), (!_vm.disableApprove) ? _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(12)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-white buttons",
    attrs: {
      "type": "submit",
      "disabled": !_vm.redeemNote.isNewRedemption && _vm.isCancelButtonDisabled()
    },
    on: {
      "click": function($event) {
        _vm.redeemNote.isNewRedemption ? _vm.goBack() : _vm.showRedeemConfirmationModal()
      }
    }
  }, [_vm._v("Cancel request")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-white buttons",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableApprove
    },
    on: {
      "click": _vm.approveRedemption
    }
  }, [_vm._v("Approve payment")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-approve buttons",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmit
    },
    on: {
      "click": _vm.submitRequest
    }
  }, [_vm._v("Submit request")])])])])])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      All users\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Principal amount:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Interest due:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', [_c('span', [_vm._v("Full")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', [_c('span', [_vm._v("Partial")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Bank account *")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('label', [_vm._v("Principal to redeem: *")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('label', [_vm._v("Service fee:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('label', [_vm._v("Principal to repay:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('label', {
    staticClass: "mt-sm pt-sm"
  }, [_vm._v("Interest payment:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('label', [_vm._v("Total paid to investor:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Redemption Category *")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "alert alert-info tip-alert"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n                  All transactions must be entered by "), _c('strong', [_vm._v("4:55 p.m. ET")]), _vm._v(" to be processed today.\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-393a6e04","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Redeem.vue
// module id = 2139
// module chunks = 1